import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PenLine } from "lucide-react";

export default function Journal() {
  const [entries, setEntries] = useState([]);
  useEffect(() => { api.get("/journal/mine").then((r) => setEntries(r.data)); }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 fade-up">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">Your practice, over time</div>
        <h1 className="font-serif text-4xl text-[#0B1E36]">Reflection journal</h1>
      </div>

      {entries.length === 0 ? (
        <div className="bg-white p-12 rounded-2xl border border-slate-200 text-center">
          <PenLine className="h-8 w-8 text-slate-300 mx-auto mb-4" />
          <div className="font-serif text-xl text-[#0B1E36] mb-2">Your journal is empty.</div>
          <p className="text-slate-600 text-sm mb-6">Reflections from completed lessons will appear here.</p>
          <Link to="/app/lessons" data-testid="journal-to-lessons" className="inline-block bg-[#EC4899] text-white px-6 py-2.5 rounded-full font-semibold">Browse lessons</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {entries.map((e) => (
            <div key={e.id} className="bg-white p-7 rounded-2xl border border-slate-200" data-testid={`journal-${e.id}`}>
              <div className="flex items-center justify-between mb-2 text-xs text-slate-500">
                <span className="uppercase tracking-widest font-semibold text-[#EC4899]">{e.lesson_title}</span>
                <span>{new Date(e.updated_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</span>
              </div>
              <p className="text-[#0B1E36] leading-relaxed whitespace-pre-wrap">{e.reflection}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
